import { getModule } from 'vuex-module-decorators'
import NavigationModule from '@/store/navigation'
import LayersModule from '@/store/layers'
import ContextModule from '@/store/context'
import SearchModule from '@/store/search'
import StorageModule from '@/store/storage'
import MapModule from '@/store/map'

export const navigation = getModule(NavigationModule)
export const layers = getModule(LayersModule)
export const context = getModule(ContextModule)
export const search = getModule(SearchModule)
export const storage = getModule(StorageModule)
export const map = getModule(MapModule)
